import { Component, Inject } from '@angular/core'
import { Incident } from '../../../models/incident.interface'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DatePipe, NgFor, NgIf } from '@angular/common'
import {
    MatCard,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
} from '@angular/material/card'

@Component({
    selector: 'app-incident-detail',
    standalone: true,
    imports: [
        NgIf,
        MatCard,
        MatCardHeader,
        MatCardSubtitle,
        DatePipe,
        NgFor,
        MatCardTitle,
    ],
    templateUrl: './incident-detail.component.html',
    styleUrl: './incident-detail.component.css',
})
export class IncidentDetailComponent {
    incident: Incident | null = null

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { incident: Incident },
        private dialogRef: MatDialogRef<IncidentDetailComponent>
    ) {}

    ngOnInit(): void {
        this.incident = this.data.incident
    }

    closeDialog() {
        this.dialogRef.close()
    }
}
